module.exports = __webpack_public_path__ + "img/a curious festival.6e750efe.png";